import SwitchController from 'components/practice/Settings/components/HealthcareProgram/components/PaymentProgramTab/components/PaymentSettings/components/SwitchController/SwitchController';
import Badge from 'components/shared/Badge/Badge';
import Typography from 'components/shared/Typography/Typography';

const BalanceBilling = ({ value = false, onChange }) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <Typography variant="label" size="large" weight="medium">
            Balance billing
          </Typography>
          <Badge text="Optional" variant="lighter" size="small" />
        </div>
        <Typography variant="p" size="small">
          Bill the patient for the remainder after insurance pays, up to your practice fees.
        </Typography>
      </div>
      <SwitchController
        title="Balance bill the patient"
        description={
          <>
            When enabled, the remaining balance after insurance may be billed to the patient,{' '}
            <span className="font-semibold">
              not to exceed your practice fees for the services rendered
            </span>
            .
          </>
        }
        checked={value}
        onChange={onChange}
      />
    </div>
  );
};

export default BalanceBilling;
